module.exports = __webpack_public_path__ + "static/media/mo.59c91c04.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mo.svg
// module id = 714
// module chunks = 0